export default "<button mat-mini-fab (click)=\"reset()\">\n  <mat-icon>refresh</mat-icon>\n</button>\n";